var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultiselectUnblockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160545",
    "data-name": "Group 160545",
    transform: "translate(-352 -1232)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1920",
    "data-name": "Rectangle 1920",
    width: 16,
    height: 16,
    transform: "translate(352 1232)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "lock-open-outline",
    transform: "translate(260.638 1203.534)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2281",
    "data-name": "Path 2281",
    d: "M176,33.7a1.992,1.992,0,0,1,3.939,0v2.037",
    transform: "translate(-81.768 -0.534)",
    fill: "none",
    stroke: "#0032c5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1923",
    "data-name": "Rectangle 1923",
    width: 8,
    height: 6,
    rx: 2,
    transform: "translate(95.362 35.478)",
    fill: "none",
    stroke: "#0032c5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_245",
    "data-name": "Ellipse 245",
    transform: "translate(359 1241)",
    fill: "none",
    stroke: "#0032c5",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 0.5,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiselectUnblockIcon);
export default __webpack_public_path__ + "static/media/MultiselectUnblock-icon.ea893fb766ae577942fa460997d3c8ad.svg";
export { ForwardRef as ReactComponent };